<template>
  <div class="in-product-detail">
    <PagesPath v-if="product && product.title" :pathTitle="product.title" :pathTitle1="'محصولات'" :pathTo1="'/products'"
               :pathTitle2="product != null ? product.title : ''"></PagesPath>
    <main class="main container product-details-main">
                 <section class="d-flex gap-29 mt-4">
                  <div class="SimilarProducts box-shadow-section-detail border-r-12" v-if="relatedProducts && relatedProducts.length" >
                    <!-- <SimilarProducts v-if=" product&&!product.isPreview" :related="relatedProducts"/> -->
                    <h3 class="title-SimilarProducts title-line-right">
                      محصولات مرتبط
                    </h3>
                    <Product v-if=" product&&!product.isPreview" :theme="'detaile'" v-for="(product, index) in relatedProducts"
                    :key="index" :product="product"></Product>

                  </div>
                  <div class="content-product-detail " :class="{'w-100':relatedProducts && !relatedProducts.length}">
                    <ProductContent class="white-bg " :comparable="true" v-model="product" :sets="productSets"/>
                    <div class="product-specifications-comments">
                    
                      <div v-if="product != null &&!product.isPreview" class="tab-content">
                    
                        <ul v-if="product != null" class="nav nav-tabs box-shadow-section-detail border-bottom py-4 px-1">
                          <li
                            v-if="product != null && product.description"
                            :class="activeTab === 'review' ? 'active' : ''"
                          >
                            <a
                              class="px-sm-3 p-2 m-1 text-color-444 fontsize16 font-weight-bold"
                              data-toggle="tab"
                              :class="activeTab === 'review' ? 'active' : ''"
                              @click="changeTab('review')"
                            >
                              نقد بررسی
                            </a>
                          </li>
                          <li
                            v-if="
                              product != null &&
                                product.specifications &&
                                product.specifications != ''
                            "
                            :class="activeTab === 'specifications' ? 'active' : ''"
                          >
                            <a
                              class="px-sm-3 p-2 m-1 text-color-444 fontsize16 font-weight-bold"
                              data-toggle="tab"
                              :class="activeTab === 'specifications' ? 'active' : ''"
                              @click="changeTab('specifications')"
                            >
                              مشخصات
                            </a>
                          </li>
                          <li :class="activeTab === 'comments' ? 'active' : ''">
                            <a
                              class="px-sm-3 p-2 m-1 text-color-444 fontsize16 font-weight-bold"
                              data-toggle="tab"
                              :class="activeTab === 'comments' ? 'active' : ''"
                              @click="changeTab('comments')"
                            >
                              نظرات کاربران
                            </a>
                          </li>
                          <!-- <li :class="activeTab === 'productQuestion' ? 'active' : ''">
                            <a
                              class="px-sm-3 p-2 m-1 text-color-444 fontsize16 font-weight-bold"
                              data-toggle="tab"
                              :class="activeTab === 'productQuestion' ? 'active' : ''"
                              @click="changeTab('productQuestion')"
                            >
                            پرسش و پاسخ
                            </a>
                            <a class="border-r-25 padding-t-5 padding-b-5 padding-r-10 padding-l-10 text-color-444 fontsize-small" @click="scrollToTab('productQuestion')">پرسش و پاسخ</a>
                          </li> -->
                        </ul>
                        <ul v-else class="nav nav-tabs border-bottom py-4 px-1">
                          <li class=" active">
                            <a
                              class="px-sm-3 p-2 m-1 text-color-444 fontsize14 font-weight-bold active"
                              data-toggle="tab"
                              href="#review"
                            >
                              نقد بررسی
                            </a>
                          </li>
                        </ul>
                        <div v-if="product != null && !product.isPreview" class="tab-content  ">
                          <ProductReview class="bg-white border-r-b-l-12 border-r-b-r-12" :activeTab="activeTab" :product="product" />
                          <ProductSpecifications class="bg-white border-r-b-l-12 border-r-b-r-12 p-3"
                            v-if="product != null && product.specifications != ''"
                            :activeTab="activeTab"
                            :product="product"
                          />
                          <ProductComments class="bg-white border-r-b-l-12 border-r-b-r-12" :activeTab="activeTab" :product="product" />
                          <!-- <ProductQuestion class="bg-white border-r-b-l-12 border-r-b-r-12" :activeTab="activeTab" :product="product" /> -->

                        </div>
                 
                      </div>
                      <div v-else class="tab-content mt-5">
                        <div id="review" class="tab-pane fade in active show">
                          <p class="fontsize14 text-color-666 text-justify line-height2 p-3">
                            <b-skeleton width="100%"></b-skeleton>
                            <b-skeleton width="100%"></b-skeleton>
                            <b-skeleton width="100%"></b-skeleton>
                            <b-skeleton width="100%"></b-skeleton>
                            <b-skeleton width="85%"></b-skeleton>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                 </section>
                 <!-- <ProductSetSlider
                 v-if="product && !product.isPreview"
                 :sets="productSets"
               /> -->
      <ScrollToTop></ScrollToTop>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import PagesPath from "@/parts/Front/components/PagesPath";
import Product from "@/parts/Front/components/product/newProduct";
// import ProductSimilar from "@/parts/Front/components/product/ProductSimilar";
import ProductSetSlider from "@/parts/Front/components/productDetail/ProductSetSlider";


import ScrollToTop from "@/parts/Front/components/ScrollToTop";
import ProductServices from "@/parts/Front/components/productDetail/ProductServices";
import ProductComments from "@/parts/Front/components/productDetail/ProductComments";
// import ProductQuestion from "@/parts/Front/components/productDetail/ProductQuestion";
import ProductSpecifications from "@/parts/Front/components/productDetail/ProductSpecifications";
import ProductReview from "@/parts/Front/components/productDetail/ProductReview";
// import SimilarProducts from "@/parts/Front/components/productDetail/SimilarProducts";
import ProductContent from "@/parts/Front/components/productDetail/ProductContent";
import product from "@/parts/Front/components/productDetail/classes/product";
import ProductCongratulations from "@/parts/Front/components/productDetail/ProductCongratulations";
import config from '@/config'
import {BSkeleton} from 'bootstrap-vue'

export default {
  name: "ProductDetails",
  components: {
    ProductCongratulations,
    PagesPath,
    ScrollToTop,
    ProductServices,
    ProductComments,
    // ProductQuestion,
    ProductSpecifications,
    ProductReview,
    // SimilarProducts,
    ProductContent,
    BSkeleton,
    Product,
    // ProductSimilar
    ProductSetSlider
  },
  data() {
    return {
      url: 'front/products/',
      title: '',
      disabled: false,
      relatedProducts: Array(5).fill(null),
      productSets: Array(5).fill(null),
      product: null,
      activeTab: "review",
    }
  },
  mounted() {
    // this.$store.dispatch('front/getProductDataFromServer', this.$route.params.id)
    if (this.$route.params.id) {
      this.getProduct(this.$route.params.id)
    }

    this.onResize()
    window.removeEventListener('resize', this.onResize)
    window.addEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      const bodyWidth = document.body.offsetWidth;
      const colorChooseImg = document.querySelectorAll('.color-choose-img')[0];
      // const productDetContent=document.querySelectorAll('.product-details-content')[0];
      if (colorChooseImg) {
        if (bodyWidth < 767) {
          colorChooseImg.style.width = (bodyWidth - 100) + "px";

        }
      }
    },
    changeTab(name) {
      // this.$store.commit('front/setProductActiveTab', name)
      this.activeTab = name
    },
    async getProduct(id) {
      this.disabled = true
      try {
        if (this.getInitialProductInfo) {
          this.product = this.getInitialProductInfo;
        }
        const response = await this.$store.dispatch(
          "front/getProductFromServer",
          id
        );
        this.product = new product(response.data.data.product, this);
        this.relatedProducts = response.data.data.relatedProducts
        this.productSets = response.data.data.settedProducts;

        // if (this.product.description != null) {
        //   this.activeTab = 'review'
        // } else if (this.product.description == null && this.product.specifications != '') {
        //   this.activeTab = 'specifications'
        // } else {
        //   this.activeTab = 'comments'
        // }
      } catch (error) {
        console.log(error);
        this.$root.errorNotify('محصول مورد نظر یافت نشد');
        this.$router.push('/')
      } finally {
        this.disabled = false
      }
    },
    scrollToTab(selectedTab){
      // let element = document.getElementById(selectedTab)
      // element.scrollIntoView({ behavior: "smooth" })
      this.activeTab = selectedTab;

    }
  },
  computed:{
    getInitialProductInfo() {
      return this.$store.getters["front/getSavedProductInfo"];
    },
  },
  metaInfo() {
    return {
      title: this.product ? config.title + ` - ${this.product.title}` : config.title,
      meta: [
        {
          name: 'description',
          content: this.product ? (this.product.meta_description ? this.product.meta_description : this.product.short_description) : false
        },
        {property: 'og:title', content: this.product ? this.product.title : false},
        {name: 'robots', content: 'index,follow'}
      ]
    }
  }
}
</script>

<style scoped>
.content-product-detail{
  width: 70%;
}
.SimilarProducts{
  width: 30%;
  padding: 20px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: fit-content;
}
.title-SimilarProducts{
  font-size: 24px;
  font-weight: 700;
  position: relative;
  padding-right: 10px;
  color: #292626;
}
.product-specifications-comments li a.active{
  background-color: var(--color-theme2);
  border-radius: 16px;
  padding: 6px 24px !important;
}
@media screen and (max-width: 1024px){
  .content-product-detail{
    width: 100%;
  }
  .SimilarProducts{
    display: none;
  }
}
.nav-tabs{
 background-color: #fff;
 margin-top: 1rem;
 border-top-right-radius: 12px;
 border-top-left-radius: 12px;
 border-bottom: 1px solid #C4C1C1;
 
}
</style>
<style>
@media screen and (max-width: 768px) {
  h2 {
    font-size: 1.6rem;
  }
  .nav-tabs{
    justify-content: space-between;
   
  }
  @media screen and (max-width:450px){
    .nav-tabs li a{
      font-size: 14px;
      padding: .25rem!important;
      margin: .12rem!important;
    }
    
  }

}
@media screen and (max-width:400px){
  .nav-tabs li a{
    font-size: 12px;
    padding: .25rem 8px!important;
    margin: .12rem!important;
    white-space: nowrap;
  }
  .nav-tabs{
    gap: 1rem;
  }
  .product-details-main .product-specifications-comments li a.active{
    background-color: var(--color-theme2);
    border-radius: 16px;
    padding: 6px 16px !important;
}
  
}
</style>
